import { Flex, Grid } from "@aircall/tractor";

import { Player } from "../Player/Player";
import { SectionDetails } from "../SectionDetails";

import { AutoScrollProvider } from "@/providers/AutoScrollContext/AutoScrollProvider";
import { Header } from "../Header/Header";
import { Transcription } from "../Transcription/Transcription";

export function MobileLayout() {
  return (
    <Grid gridTemplateRows="auto 1fr auto" h="100vh">
      <Header mobile />
      <AutoScrollProvider>
        <Flex flexDirection="column" overflow="auto">
          <SectionDetails mobile />
          <Transcription mobile />
        </Flex>
        <Player mobile />
      </AutoScrollProvider>
    </Grid>
  );
}
